import React from "react";
import { useMediaQuery }  from "react-responsive";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Subject from "@material-ui/icons/Subject";
import Icon from "@material-ui/core/Icon";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import AdInFeed from "components/AdSense/AdInFeed.jsx";
import office2 from "assets/img/office2.jpg";
import cardProject6 from "assets/img/examples/card-project6.jpg";
import cardBlog3 from "assets/img/examples/card-blog3.jpg";
import projectsStyle from "assets/jss/trip-kit/views/sectionsSections/projectsStyle.js";

//언어 셋팅
import { withTranslation } from "react-i18next";
import i18n from "config/lang/i18n.js";


const useStyles = makeStyles(projectsStyle);

const SectionImage = (props) =>{

  const classes = useStyles();
  
  /*
  const isPc = useMediaQuery({
    query : "(min-width: 768px)"
  })
  */
  const isMobile = useMediaQuery({
    query : "(max-width: 940px)"
  })
  

  return (
    <div className={classes.projects}>
      <div className={classes.container}>
        <GridContainer>
          {/*
          <GridItem xs={12} sm={6} md={6}>
              <Card
                raised
                background
                style={{ backgroundImage: `url(${office2})` }}
              >
                <CardBody background>
                  <h6 className={classes.cardCategory}>TRANSPORTATION</h6>
                  <a href="#pablito" onClick={e => e.preventDefault()}>
                    <h3 className={classes.cardTitleWhite}>
                    Is there a cheaper & easier way to travel around Korea?
                    </h3>
                  </a>
                  <p className={classes.cardDescription} style={{fontWeight:"400"}}>
                  There are a variety of transportation cards for both buses and trains which can be used to get discounted fares, while also cutting out the need for carrying cash.
                  </p>
                  <a href='https://english.visitkorea.or.kr/enu/TRP/TP_ENG_8_1_1.jsp'  target='_blank' rel="noopener noreferrer">
                  <Button round color="danger">
                    <Subject /> more information
                  </Button>
                  </a>
                </CardBody>
              </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
              <Card
                  raised
                  background
                  style={{ backgroundImage: `url(${cardBlog3})` }}
                >
                  <CardBody background>
                    <h6 className={classes.cardCategory}>TEMPLESTAY</h6>
                    <a href="#pablito" onClick={e => e.preventDefault()}>
                      <h3 className={classes.cardTitleWhite}>
                      What are the temple stay programs available in Korea?
                      </h3>
                    </a>
                    <p className={classes.cardDescription} style={{fontWeight:"400"}}>
                    Temple stay programs are divided largely into three different categories: relaxation, experience, and practice-focused. The availability of programs varies by temple.
                    </p>
                    <a href='https://english.visitkorea.or.kr/enu/ATR/SI_ENG_2_6.jsp'  target='_blank' rel="noopener noreferrer">
                    <Button round color="info">
                    <Subject />
                      more information
                    </Button>
                    </a>
                  </CardBody>
                </Card>
          </GridItem>
         
          <GridItem xs={12} sm={12} md={12}>
            <Card
              raised
              background
              style={{ backgroundImage: `url(${cardProject6})` }}
            >
              <CardBody background>
                <h6 className={classes.cardCategory}>{i18n.t('mainBottomAccommodation')}</h6>
                <a href={i18n.t('hotelscombinedUrl')}  target='_blank' rel='nofollow noopener noreferrer'>
                  <h3 className={classes.cardTitleWhite}>
                  {i18n.t('mainBottomAccommodationTitle')}
                  </h3>
                </a>
                <p className={classes.cardDescription} style={{fontWeight:"400"}}>
                {i18n.t('mainBottomAccommodationDetail')}
                </p>
                <a href={i18n.t('hotelscombinedUrl')}  target='_blank' rel='nofollow noopener noreferrer'>
                <Button round color="warning">
                <Icon>content_copy</Icon> {i18n.t('mainBottomAccommodationButton')}
                </Button>
                </a>
              </CardBody>
            </Card>
          </GridItem> 
          */}
          <GridItem xs={12} sm={12} md={12} style={{marginTop:"20px",marginBottom:"20px"}}>  
          {
            isMobile ?
            <AdInFeed currentPath={props.location+"/1774574227"} slot="1774574227" layoutKey="-6t+ed+2i-1n-4w"/>
            :
            <GridContainer justify="center">
            <GridItem xs={12} sm={4} md={4} >
              <AdInFeed currentPath={props.location+"/1980542061"} slot="1980542061" layoutKey="-hg-3+1f-3d+2z"/>
            </GridItem>
            <GridItem xs={12} sm={8} md={8} >
              <AdInFeed currentPath={props.location+"/2177064759"} slot="2177064759" layoutKey="-gy-f+6g+f-4n"/>
            </GridItem>
            </GridContainer>
          }
           </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
export default withTranslation()(SectionImage);